import React from 'react';
import { NavbarPropTypes } from 'react-day-picker';
import Icon from '../../nth-bit-icon-button';
import Chevron from '../../nth-chevron';

const Navbar = ({
  style,
  className,
  showPreviousButton,
  showNextButton,

  // `onPreviousClick` and `onNextClick` take a callback function as an arument.
  // Therefore one may not pass them directly to the `onClick` attribute because
  // `onClick` will pass an event object, that will cause a non-fatal error.
  onPreviousClick,
  onNextClick,
}) => (
  <div className={className}>
    {showPreviousButton && (
      <div style={{ float: 'left' }}>
        <Icon onClick={() => onPreviousClick()}>
          <Chevron style={style} direction="left" />
        </Icon>
      </div>
    )}
    {showNextButton && (
      <div style={{ float: 'right' }}>
        <Icon onClick={() => onNextClick()}>
          <Chevron style={style} direction="right" />
        </Icon>
      </div>
    )}
  </div>
);

Navbar.defaultProps = {
  style: {},
};

Navbar.propTypes = {
  ...NavbarPropTypes,
  style: Chevron.propTypes.style,
};

export default Navbar;
